// extracted by mini-css-extract-plugin
module.exports = {"title":"title__PwOia","attribute":"attribute__3ZeDe","wrap":"wrap__3YAVO"};